export default "__VITE_ASSET__21ed69f0__"